'use client';
import Link from 'next/link';
import Image from 'next/image';
import { ErrorBoundary } from 'react-error-boundary'
import { ERROR } from '@/shared/utils/const';

const ErrorFallback = ({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) => {
  // 에러 타입에 따른 메시지 설정
  let errorTitle = "문제가 발생했습니다"
  let errorMessage = error.message

  if (error.message.includes("Server Components render")) {
    errorTitle = "서버 컴포넌트 렌더링 오류"
    errorMessage = "서버에서 데이터를 불러오는 중 문제가 발생했습니다. 잠시 후 다시 시도해주세요."
  } else if (error.message.includes("authentication") || error.message.includes("auth")) {
    errorTitle = "인증 오류"
    errorMessage = "로그인 상태를 확인해주세요. 다시 로그인해주세요."
  } else if (error.message.includes("fetch") || error.message.includes("network")) {
    errorTitle = "네트워크 오류"
    errorMessage = "네트워크 연결을 확인해주세요."
  }
  return (
    <div className="not-found">
      <div className="inner">
        <div className="icon"></div>
        <p className="title">{errorTitle}</p>
        <p className="text">{errorMessage}</p>
        <div className="notice">문제가 지속되면 관리자에게 문의해주세요.</div>
      </div>
    </div>
  );
};

export const AppErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // 에러 발생 시 상태를 초기화하는 로직
        window.location.reload()
      }}
      onError={(error, errorInfo) => {
        // 에러 로깅
        console.error('ErrorBoundary caught an error:', error, errorInfo)
      }}
    >
      {children}
    </ErrorBoundary>
  )
}